export interface PriorScrubSignal {
  scrubbingSourceCode?: 'Manual' | 'Rule' | 'LLM';
  aiOverallScore?: number;
}

export function hasPriorAgentScrub(summaries: readonly PriorScrubSignal[]): boolean {
  return summaries.some(
    (s) => s.aiOverallScore != null || s.scrubbingSourceCode === 'LLM' || s.scrubbingSourceCode === 'Rule',
  );
}
